import * as React from 'react';

export interface ConservatorIconProps {
  className?: string;
  size?: number;
  title?: string;
}

/**
 * ConservatorIcon — PCB Retail Modal entity icon (v2.5)
 *
 * @description Court-appointed conservator. Wooden gavel resting on a strike pad.
 */
const ConservatorIcon: React.FunctionComponent<ConservatorIconProps> = ({
  className,
  size = 40,
  title = 'Conservator (Court-Appointed)',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={size}
    height={size}
    className={className}
    role="img"
    aria-label={title}
  >
    <title>{title}</title>
      <rect x="6" y="34" width="36" height="6" rx="1" fill="#5a3508"/>
      <rect x="6" y="34" width="36" height="1.5" fill="#a87c1a"/>
      <rect x="6" y="20" width="22" height="3.5" rx="0.5" fill="#7a4a14"/>
      <rect x="6" y="20" width="3" height="3.5" fill="#3a2208"/>
      <rect x="28" y="14" width="14" height="16" rx="1" fill="#7a4a14" stroke="#3a2208" strokeWidth="0.8"/>
      <rect x="28" y="17" width="14" height="1.5" fill="#3a2208"/>
      <rect x="28" y="26" width="14" height="1.5" fill="#3a2208"/>
      <rect x="26" y="20" width="3" height="3.5" fill="#3a2208"/>
  </svg>
);

export default ConservatorIcon;
